export default __webpack_public_path__ + "static/media/doubleGreenTick.cd5f0711.svg";